import {
    SOCIETY_GET_EMPLOYEES_LIST,
    SOCIETY_GET_EMPLOYEE_DETAILS,
    SOCIETY_CREATE_EMPLOYEE,
    SOCIETY_UPDATE_EMPLOYEE,
    SOCIETY_DELETE_EMPLOYEE,
    SOCIETY_GET_EMPLOYEE_TYPES,
    SOCIETY_GET_COUNTRIES_DROPDOWN,
    SOCIETY_GET_EMPLOYEE_AUDIT_LOG,
    SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL,
    SOCIETY_CLEAR_EMPLOYEE_SEARCH,
    SOCIETY_LINK_EXISTING_EMPLOYEE,
    SOCIETY_GET_USERNAMES_DROPDOWN,
    SOCIETY_GET_EMPLOYEES_DROPDOWN,
} from '../../index.types';

export const getEmployeesList = (data) => ({ type: SOCIETY_GET_EMPLOYEES_LIST, data });
export const getEmployeeDetails = (data) => ({ type: SOCIETY_GET_EMPLOYEE_DETAILS, data });
export const createEmployee = (data) => ({ type: SOCIETY_CREATE_EMPLOYEE, data });
export const updateEmployee = (data) => ({ type: SOCIETY_UPDATE_EMPLOYEE, data });
export const deleteEmployee = (data) => ({ type: SOCIETY_DELETE_EMPLOYEE, data });
export const getEmployeeTypes = (data) => ({ type: SOCIETY_GET_EMPLOYEE_TYPES, data });
export const getCountriesDropdown = (data) => ({ type: SOCIETY_GET_COUNTRIES_DROPDOWN, data });
export const getEmployeeAuditLog = (data) => ({ type: SOCIETY_GET_EMPLOYEE_AUDIT_LOG, data });
export const searchEmployeeByEmail = (data) => ({ type: SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL, data });
export const clearEmployeeSearch = () => ({ type: SOCIETY_CLEAR_EMPLOYEE_SEARCH });
export const linkExistingEmployee = (data) => ({ type: SOCIETY_LINK_EXISTING_EMPLOYEE, data });
export const getUsernamesDropdown = (data) => ({ type: SOCIETY_GET_USERNAMES_DROPDOWN, data });
export const getEmployeesDropdown = (data) => ({ type: SOCIETY_GET_EMPLOYEES_DROPDOWN, data });
